export const buildUrlDownload = (fileUrl, token) => {
  return `${process.env.REACT_APP_API_URL}${fileUrl}?access_token=${token}`;
};
